// extracted by mini-css-extract-plugin
module.exports = {"container":"DiscountItem_index_container__3DmHR","minusIcon":"DiscountItem_index_minusIcon__CByIZ"};